import * as React from 'react';
import Box from '@mui/material/Box';
import styles from "../css/FtTrsp.module.css";
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
import { useEffect, useState } from "react"
import VideoModal from "utils/videoModal";
import IframeModal from 'utils/iFrameModal';
import { useTranslation } from 'react-i18next';
export default function FutureTransportationViewM() {
  const [showIframe, setShowIframe] = useState(false);

  const [videoOpen, setVideoOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  // useNavigation(mapMessages);
  const openInNewWindow = (e) => {
    e.preventDefault();
    window.open(
      "http://192.168.0.190:8080/TFlow/main.do",
      "tflow",
      "width=3460,height=1800,menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes"
    );
  };

  const openVideo = (src) => {
    setVideoSrc(src);
    setVideoOpen(true);
  };


  const getVideoPath = (basePath, hasLanguageVersion = false) => {
    if (!hasLanguageVersion) return basePath;

    const language = i18n.language || 'kr';
    const pathWithoutExtension = basePath.replace('.mp4', '');
    console.log('language :::',language)
    console.log('pathWithoutExtension :::',pathWithoutExtension)
    return language === 'en' ? `${pathWithoutExtension}_en.mp4` : `${pathWithoutExtension}_kr.mp4`;
  };

  const handleTflowClick = () => {
    setShowIframe(true);
  };

  const { mapMessages, clearLastMapMessage } = useDashboard();
  useNavigation(mapMessages);
  useEffect(() => {
    if (mapMessages.length > 0) {
      clearLastMapMessage();
    }
  }, [mapMessages]);

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} src={videoSrc} />

      <div className={`{${styles.ftTrspM_container} container`}>
        <div className="contWrap L_lmr">
          <div className="L_3m L_tb ">
            <div className='L_d inner flx flx_col'>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-08)' }}>{t('High Definition Map')}</h2>
              </div>
              <div className={`${styles.atDrPrBoxCont} boxCont flx gap40`} style={{ overflow: 'hidden' }}>
                <div className={`${styles.txtBox_th} ${styles.L_lr_FtTrsp}  flx flx_col a_center j_center gap20`}>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>정밀도로지도 구축</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>GPS/INS Geo Processing</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>노드, 차로, 차선 등 Vectorizing</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>DB구조화</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>정밀 지도 검수/검증</p>
                </div>
                <div className={`${styles.L_lr_FtTrsp}`}>
                  {/* <img
                    src="/images/module/DetailMap.gif"
                    alt="DetailMap"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo('/video/DetailMap.mp4')}
                  /> */}
                  <img
                    src="/images/module/DetailMap.gif"
                    alt="DetailMap"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo(getVideoPath('/video/DetailMap.mp4', true))}
                  />
                </div>
              </div>
            </div>
            <div className='L_d flx flx_col inner gap40'>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-08)' }}>{t('Autonomous Driving Control')}</h2>
              </div>
              <div className={`${styles.atDrBoxCont} boxCont flx gap40`} style={{ overflow: 'hidden', height: '100%', flex: '1', margin: '0' }}>
                <div className={`${styles.txtBox_th} ${styles.L_lr_FtTrsp}  flx flx_col a_center j_center gap20`}>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>자율주행 솔루션 탑재</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>정밀지도 기반 차선단위 위치 정확도</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>주행예정경로 시각화</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>현실과 유사한 도로형태 시각화</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>레이더, 라이더 등 센서 기반 주변환경 인식</p>
                </div>
                <div className={`${styles.L_lr_FtTrsp}`}>
                  <img
                    src="/images/module/futureDrive.gif"
                    alt="futureDrive"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo('/video/futureDrive.mp4')}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="inner L_3m">
            <div className="titWrap flx a_center j_spc_btw">
              <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-12)' }}>{t('CellularDataforTrafficAnalysis')}</h2>
            </div>
            <div className={`${styles.tflowBoxCont} boxCont flx a_center j_center`} style={{ position: 'relative' }}>
              <img
                src="/images/module/Tflow_mdul_od.png"
                alt="TFLOW"
                // onClick={handleTflowClick}
                onClick={openInNewWindow}
                style={{ cursor: 'pointer' }}
              />
              {/* {showIframe && (
                <IframeModal
                  // src="http://192.168.0.190:8080/TFlow/main.do"
                  src="http://limes.kr:8888/TFlow_AT/"
                  title="다른 프로젝트"
                  width="100%"
                  height="100%"
                  style={{
                    border: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 10
                  }}
                />
              )} */}
            </div>
          </div>
          <div className="L_3m L_tb">
            <div className='L_d inner flx flx_col'>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>{t('Cooperative-IntelligentTransportSystems')}</h2>
              </div>
              <div className={`${styles.CarviBoxCont} boxCont flx gap40`} style={{ overflow: 'hidden' }}>
                <div className={`${styles.txtBox_th} ${styles.L_lr_FtTrsp}  flx flx_col a_center j_center gap10`}>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>안전운전 지원</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>교차로통행 지원</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>교통약자 보호</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>긴급상황 지원</p>
                </div>
                <div className={`${styles.L_lr_FtTrsp}`}>
                  {/* <img
                    src="/images/module/C_ITS.GIF.gif"
                    alt="C_ITS"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo('/video/c-its-20250516.mp4')}
                  /> */}
                  <img
                    src="/images/module/C_ITS.GIF.gif"
                    alt="C_ITS"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo(getVideoPath('/video/c-its-20250516.mp4', true))}
                  />
                </div>
              </div>
            </div>
            <div className='L_d inner flx flx_col'>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-06)' }}>{t('PedestrianSimulation')}</h2>
              </div>
              <div className={`${styles.VisWBoxCont} boxCont flx gap40`} style={{ overflow: 'hidden' }}>
                <div className={`${styles.txtBox_th} ${styles.L_lr_FtTrsp}  flx flx_col a_center j_center gap20`}>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>아태총회 행사장 내부 3D 시각화</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>관람객 이동 동선,속도 시뮬레이션</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>구역별 인원 밀집도 예측</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>화재/재난 상황 대피 시뮬레이션</p>
                  <p className={`${styles.txt} innerBg flx a_center j_center`}>동선 재정비 및 안전사고 예방</p>
                </div>
                <div className={`${styles.L_lr_FtTrsp}`}>
                  <img
                    src="/images/module/V_WALK.gif"
                    alt="V_WALK"
                    style={{ cursor: 'pointer', height: '100%' }}
                    onClick={() => openVideo('/video/V_WALK.mp4')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}